import { SUB_CATEGORY } from "../types/subCategory.type";

const initialState = {
  loading: true,
  data: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUB_CATEGORY.SUCCESS_FETCH:
      return {
        loading: false,
        data: action.payload,
        error: "",
      };
    case SUB_CATEGORY.FAIL_FETCH:
      return {
        loading: false,
        data: [],
        error: action.payload,
      };
    default:
      return { ...state };
  }
};
export default reducer;
